import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaComment,
  FaMapMarkerAlt,
  FaPhone,
  FaLinkedin,
} from "react-icons/fa";
import "./ContactSection.css";
import emailjs from "@emailjs/browser";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({}); // Track errors for each input

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setError("");
    setErrors((prevErrors) => ({ ...prevErrors, [name]: false })); // Clear error for this field
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if fields are empty
    const newErrors = {};
    if (!formData.name) newErrors.name = true;
    if (!formData.surname) newErrors.surname = true;
    if (!formData.email) newErrors.email = true;
    if (!formData.message) newErrors.message = true;

    // Set errors if fields are empty
    if (Object.keys(newErrors).length > 0) {
      setError("Please fill in all fields.");
      setErrors(newErrors); // Update errors state with the new errors
      return;
    }

    // Check for valid email
    if (!validateEmail(formData.email)) {
      setError("Please enter a valid email address.");
      setErrors((prevErrors) => ({ ...prevErrors, email: true })); // Set email field error
      return;
    }

    setError("");
    setErrors({}); // Clear errors if validation passes

    try {
      const response = await emailjs.send(
        "service_ypkusk7",
        "template_1ob0tfu",
        {
          to_name: "Huyser Admin",
          from_name: `${formData.name} ${formData.surname}`,
          name: formData.name,
          surname: formData.surname,
          email: formData.email,
          message: formData.message,
        },
        "yKfia-cezGeWGsZat"
      );

      setStatusMessage("Message sent successfully!");
      setShowSuccess(true);
      setFormData({ name: "", surname: "", email: "", message: "" });

      setTimeout(() => {
        setShowSuccess(false);
        setStatusMessage("");
      }, 3000);

      console.log("Email sent successfully:", response.status, response.text);
    } catch (error) {
      setStatusMessage("Failed to send message. Please try again.");
      console.error("Email sending failed:", error);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-us-header">
        <p>Contact Us</p>
      </div>

      <div className="contact-container">
        <div className="info-section">
          <h3>
            <span className="find">Find Us</span>
          </h3>
          <p>
            <FaMapMarkerAlt className="info-icon" />
            <span>
              Head Office: 80 Greenvale Road, Sami G Office Square, Level 7,
              Meadowdale, Edenvale, 1401
            </span>
          </p>
          <p>
            <FaPhone className="info-icon" />
            <span className="contact-info">
              {" "}
              <a href="tel:(+27) 01 003 7860">
                {" "}
                (+27) 01 003 7860 (Main Office)
              </a>{" "}
            </span>
          </p>
          <p>
            <FaEnvelope className="info-icon" />
            <span className="contact-info">
              {" "}
              <a href="mailto:contact@huyserindustries.com">
                contact@huyserindustries.com
              </a>{" "}
            </span>
          </p>
          <a
            href="https://www.google.com/maps/place/Huyser+Industries+SA+Pty+Ltd./@-26.1642022,28.1618909,17z/data=!3m1!4b1!4m6!3m5!1s0x1e95152eaaaaaaab:0x982d669bc606b491!8m2!3d-26.1642022!4d28.1644712!16s%2Fg%2F11mx60ch5d?entry=ttu&g_ep=EgoyMDI0MTAyMi4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            Find Us on Google Maps
          </a>
          <div className="social-icons">
            <span className="linkedin-icon">
              <a
                href="https://www.linkedin.com/company/huyser-industries/?originalSubdomain=za"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="social-icon" />
              </a>
            </span>
          </div>
        </div>

        <div className="form-section">
          {showSuccess && <div className="status-message">{statusMessage}</div>}
          {error && <div className="error-message">{error}</div>}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "input-error" : ""}
                required
              />
            </div>

            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="surname"
                placeholder="Surname"
                value={formData.surname}
                onChange={handleChange}
                className={errors.surname ? "input-error" : ""}
                required
              />
            </div>

            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "input-error" : ""}
                required
              />
            </div>

            <div className="input-group">
              <FaComment className="input-icon" />
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? "input-error" : ""}
                rows="5"
                required
              />
            </div>

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
